module.exports = __webpack_public_path__ + "static/media/HighFive_LockUp.30b51e9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/HighFive_LockUp.svg
// module id = 650
// module chunks = 0